var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-block__splashscreen",class:{
    primary:
      _vm.$voicer.getConfig('enabledSplashScreen') ||
      _vm.$voicer.getConfig('enabledSplashScreen.mode') === 'classic',
  }},[_c('img',{staticClass:"pa-1",attrs:{"src":require('~/assets/images/splashscreenv2.png'),"width":"400"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }